"use strict";
/**
 * Created by Pankaj on 2019-12-12.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NolimitBonusView = void 0;
const FeatureBasePanel_1 = require("../FeatureBasePanel");
const BetPanelView_1 = require("../../components/BetPanelView");
const FeatureBuyTicket_1 = require("../../components/FeatureBuyTicket");
const NolimitApplication_1 = require("@nolimit/slot-launcher/bin/NolimitApplication");
const PromoPanelAssetConfig_1 = require("../../config/PromoPanelAssetConfig");
const PromoPanelLabelIDs_1 = require("../../enums/PromoPanelLabelIDs");
const PromoPanelConfig_1 = require("../../config/PromoPanelConfig");
const NolimitPromotionPlugin_1 = require("../../NolimitPromotionPlugin");
const Helper_1 = require("../../utils/Helper");
const PromoPanelTextStyles_1 = require("../../config/PromoPanelTextStyles");
const ImgLoader_1 = require("@nolimit/slot-launcher/bin/loader/ImgLoader");
const PromoPanelButtonIDs_1 = require("../../enums/PromoPanelButtonIDs");
class NolimitBonusView extends FeatureBasePanel_1.FeatureBasePanel {
    constructor(controller, scroll) {
        super(PromoPanelAssetConfig_1.PromoPanelAssetConfig.NOLIMIT_BONUS_ICON, NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(PromoPanelLabelIDs_1.PromoPanelLabelIDs.BUY_FEATURE_TITLE), PromoPanelTextStyles_1.PromoPanelTextStyles.FEATURE_BASE_BUY_FEATURE_TITLE);
        this._featureBuyTickets = [];
        this._controller = controller;
        this._featureContainer = new PIXI.Container();
        this._featureContainer.name = "FEATURE_CONTAINER";
        this._scroll = scroll;
        this.init();
    }
    onBetChange(bet) {
        this.betPanel.setValue(+bet);
    }
    onBalanceUpdate(balance) {
        this._featureBuyTickets.forEach((gameFeatureView) => {
            gameFeatureView.updateButtons();
        });
    }
    init() {
        super.init();
        this.betPanel = new BetPanelView_1.BetPanelView(PromoPanelButtonIDs_1.PromoPanelButtonIDs.BET_UP, PromoPanelButtonIDs_1.PromoPanelButtonIDs.BET_DOWN, (button) => this._controller.buttonClick(button), PIXI.utils.string2hex("#d61d49"));
        this.addChild(this.betPanel);
        this.addChild(this._featureContainer);
        this.popUp = this._controller.promotionPlugin.view.popUpView;
    }
    /**
     * To create feature list view. only FEATURE_FILTER_LIST have feature list will be created.
     *
     */
    createGameFeatureList(bonusFeatures) {
        this._featureContainer.removeChildren();
        this._featureBuyTickets.length = 0;
        const buyButtonTexture = ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.BUY_BTN);
        for (let featureData of bonusFeatures) {
            const gameFeatureView = new FeatureBuyTicket_1.FeatureBuyTicket(featureData, (button, featureData) => this._controller.buttonClick(button, featureData), buyButtonTexture);
            this._featureContainer.addChild(gameFeatureView);
            this._featureBuyTickets.push(gameFeatureView);
        }
        this._scroll.scrollEnabled = true;
        this._scroll.updateContent();
    }
    close() {
        this.closePopUp();
        super.close();
        this._scroll.visible = false;
    }
    openPopUp(featureData) {
        this.popUp.openBonusBuy((button, featureData) => this._controller.buttonClick(button, featureData), featureData);
    }
    closePopUp() {
        this.popUp.close();
        this._scroll.updateContent();
    }
    show() {
        this.betPanel.visible = true;
        this._scroll.visible = true;
        super.show();
        this._scroll.scrollEnabled = true;
        this._scroll.updateContent();
    }
    hide() {
        this.betPanel.visible = false;
        this._scroll.visible = false;
        super.hide();
    }
    updateFeaturePrice(currentBet) {
        let minPrice = Number.MAX_VALUE;
        this._featureBuyTickets.forEach((gameFeatureView) => {
            gameFeatureView.updatePrice(currentBet);
            minPrice = Math.min(minPrice, gameFeatureView.price);
        });
        return minPrice;
    }
    getNextBetMinFeaturePrice(nextCurrentBet) {
        let nextMinFeaturePrice = Number.MAX_VALUE;
        this._featureBuyTickets.forEach((gameFeatureView) => {
            gameFeatureView.updateNextBetPrice(nextCurrentBet);
            nextMinFeaturePrice = Math.min(nextMinFeaturePrice, gameFeatureView.nextBetPrice);
        });
        return +nextMinFeaturePrice.toFixed(2); //#329
    }
    onResize() {
        if (this._isOpen) {
            const bounds = NolimitApplication_1.NolimitApplication.screenBounds;
            const landscapeLayout = NolimitApplication_1.NolimitApplication.isLandscape && Helper_1.Helper.isDefaultScreenRatio(bounds);
            const newScrollRect = new PIXI.Rectangle(PromoPanelConfig_1.PromoPanelConfig.PROMO_PANEL_BTN_PANEL_HEIGHT, 0, bounds.width - PromoPanelConfig_1.PromoPanelConfig.PROMO_PANEL_BTN_PANEL_HEIGHT, bounds.height - NolimitPromotionPlugin_1.NolimitPromotionPlugin.keypadPlugin.getBalanceBarHeight() - 1);
            if (landscapeLayout) {
                this._scroll.addChild(this.betPanel); //#149
                this._featureContainer.y = 162;
            }
            else if (NolimitApplication_1.NolimitApplication.isLandscape && !Helper_1.Helper.isDefaultScreenRatio(bounds)) {
                this.addChild(this.betPanel); //#149
                this._featureContainer.y = 328;
            }
            else {
                this.addChild(this.betPanel); //#149
                this._featureContainer.y = 328;
                const topBarHeight = ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.TOP_BAR).height - 10;
                newScrollRect.width = bounds.width;
                newScrollRect.height = bounds.height - NolimitPromotionPlugin_1.NolimitPromotionPlugin.keypadPlugin.getBalanceBarHeight() - topBarHeight - PromoPanelConfig_1.PromoPanelConfig.PROMO_PANEL_BTN_PANEL_HEIGHT;
                newScrollRect.x = 0;
                newScrollRect.y = topBarHeight;
            }
            this._scroll.resize(newScrollRect.width, newScrollRect.height);
            this._scroll.position.set(newScrollRect.x, newScrollRect.y);
            this.betPanel.resize(landscapeLayout);
            super.onResize();
            this.position.set(0, 0);
            this._featureBuyTickets.forEach((gameFeatureView, index) => {
                gameFeatureView.resize(landscapeLayout);
            });
            if (landscapeLayout) {
                const ticketWidth = this._featureBuyTickets[0].width;
                const betPanelWidth = this.betPanel.width;
                let betPanelSpacing = 17;
                const totalWidth = ticketWidth + betPanelSpacing + betPanelWidth;
                const freeWidth = newScrollRect.width;
                let margin = (freeWidth - totalWidth) * 0.5;
                if (margin < -7) {
                    betPanelSpacing -= Math.abs(margin) * 2 + 7;
                    margin = -7;
                }
                this.betPanel.x = margin + ticketWidth + betPanelSpacing;
                this.betPanel.y = this._featureContainer.y;
                let yAdvance = 0;
                for (let ticket of this._featureBuyTickets) {
                    ticket.x = margin;
                    ticket.y = yAdvance;
                    yAdvance += ticket.height + 5;
                }
            }
            else {
                const freeWidth = newScrollRect.width;
                this.betPanel.x = (freeWidth - this.betPanel.width) * 0.5;
                this.betPanel.y = this._featureContainer.y - 33 - this.betPanel.height;
                let yAdvance = 0;
                for (let ticket of this._featureBuyTickets) {
                    ticket.x = (freeWidth - ticket.width) * 0.5;
                    ticket.y = yAdvance;
                    yAdvance += ticket.height + 5;
                }
            }
            this._scroll.updateContent();
        }
    }
}
exports.NolimitBonusView = NolimitBonusView;
//# sourceMappingURL=NolimitBonusView.js.map